import { Link } from "react-router-dom";
import { topics } from "@/mocks/topics";
import TopicCard from "@/components/feature/TopicCard";

export default function FeaturedPick() {
  const picks = [...topics].sort((a, b) => b.saved - a.saved).slice(0, 3);

  return (
    <section id="featured" className="w-full px-4 md:px-8 py-14 md:py-20">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
        <div>
          <span className="inline-flex items-center gap-2 text-xs font-medium tracking-widest text-primary-600 uppercase">
            <span className="w-6 h-px bg-primary-500"></span>
            Editor&apos;s Pick
          </span>
          <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            编辑精选 · 收藏最多的话题
          </h2>
          <p className="mt-3 max-w-2xl text-sm md:text-base leading-7 text-foreground-600">
            这些话题被读者反复收藏与标记，是近期讨论度与回看率都表现突出的内容，适合先存后看。
          </p>
        </div>
        <Link
          to="/topics"
          className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md border border-foreground-300 text-sm font-medium text-foreground-800 whitespace-nowrap hover:border-primary-400 hover:text-primary-700 transition-colors cursor-pointer"
        >
          查看全部话题
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-6">
        {picks.map((topic) => (
          <TopicCard key={topic.id} topic={topic} />
        ))}
      </div>
    </section>
  );
}